import React, { useEffect } from "react";
import "moment/locale/lo";
import { clearLocalStorage, newSound, socketServer, USER_KEY } from "./helper";
import _ from "lodash";

import "./index.css";
import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  from
} from "@apollo/client";

import { ApolloProvider } from "@apollo/client/react";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import Notiflix from "notiflix";
import Routes from "./Routes";

// const api = "http://localhost:4000/graphql";
const api = "https://dash.api.anousith-express.com/graphql"

const AppContext = React.createContext();

export default function App() {
  const authLink = setContext((_, { headers }) => {
    const _local = localStorage.getItem(USER_KEY);
    return {
      headers: {
        ...headers,
        authorization: _local,
      },
    };
  });

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    const isError1 = _.some(graphQLErrors, { message: "Error: TokenExpiredError: jwt expired" });
    const isError2 = _.some(graphQLErrors, { message: "Error: JsonWebTokenError: jwt must be provided" });
    const isError3 = _.some(graphQLErrors, { message: "Error: DO_NOT_HAVE_PERMISSION" });

    let message = "";
    if (isError1) message = "ການເຂົ້າລະບົບຂອງທ່ານໄດ້ໝົດອາຍຸລົງແລ້ວ ກະລຸນາເຂົ້າລະບົບໃໝ່";
    if (isError2) message = "ຂໍອະໄພ ມີຂໍ້ຜິດພາດ ກະລຸນາເຂົ້າລະບົບໃໝ່";
    if (isError3) {
      message = "ຂໍອະໄພ ບັນຊີຂອງທ່ານບໍ່ມີສິດເຂົ້າໃຊ້ງານ";
      clearLocalStorage();
    }

    if (isError1) {
      Notiflix.Report.warning("ແຈ້ງເຕືອນ", message, "ຕົກລົງ", async () => {
        Notiflix.Loading.standard("ກຳລັງດຳເນິນງານ...");
        clearLocalStorage();
        window.location.replace("/login");
      });
    }
  });

  const client = new ApolloClient({
    link: from([
      errorLink,
      authLink.concat(createHttpLink({ uri: api }))
    ]),
    cache: new InMemoryCache({ addTypename: false })
  });

  return (
    <AppContext.Provider value={{}}>
      <ApolloProvider client={client}>
        <Routes />
      </ApolloProvider>
    </AppContext.Provider>
  );
}
